"use strict";

var PyDefUtils = require("PyDefUtils");

module.exports = function(pyModule) {

    pyModule["DesignSpacer"] = Sk.misceval.buildClass(pyModule, function($gbl, $loc) {

        $loc["__init__"] = new Sk.builtin.func(PyDefUtils.withRawKwargs(function(kwargs, self) {
            Sk.misceval.call(pyModule["Spacer"].prototype["__init__"], undefined, undefined, kwargs, self);

            PyDefUtils.addHeightHandle(self._anvil);

        }));

    }, 'DesignSpacer', [pyModule["Spacer"]]);
};
